/* cl-cart.js — gaveta do carrinho do clone octipa-3 (secao cl-cart-drawer, visual do Sense dele), vanilla.
   Metas: brindes de R$ 0 (data-cl-g1v/g2v) entram ao cruzar 95/130 e saem abaixo; codigo promocional via
   /cart/update.js {discount}.
   Abre pelo evento cl:cart:open (cl-ui.js: icone do header e ATC). Toda mudanca vai pela Ajax API do carrinho e a
   gaveta e re-renderizada pelo HTML que volta na resposta do POST (sections=cl-cart-drawer). Atualiza a bolha do carrinho do
   header nativo do Horizon (cart-icon.renderCartBubble). */
(function () {
  'use strict';
  var SECTION = 'cl-cart-drawer';

  function root() { return document.querySelector('[data-cl-cart-drawer]'); }
  function drawer() { var r = root(); return r && r.querySelector('[data-cl-drawer]'); }

  function open() {
    var d = drawer(); if (!d) return;
    d.classList.add('animate', 'active');
    document.documentElement.classList.add('cl-cart-open');
    var inner = d.querySelector('.drawer__inner'); if (inner) inner.focus({ preventScroll: true });
  }
  function close() {
    var d = drawer(); if (!d) return;
    d.classList.remove('active');
    document.documentElement.classList.remove('cl-cart-open');
  }

  function bubble(count) {
    // o renderCartBubble do Horizon so liga/desliga a bolha: o numero e escrito aqui
    Array.prototype.forEach.call(document.querySelectorAll('[ref="cartBubbleCount"]'), function (e) { e.textContent = count; });
    var icon = document.querySelector('cart-icon');
    if (icon && typeof icon.renderCartBubble === 'function') { try { icon.renderCartBubble(count, true); } catch (e) {} }
  }

  // aplica o HTML da secao (vindo da resposta do POST ou do render separado); devolve a contagem renderizada
  function apply(html, keepOpen) {
    if (!html) return -1;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cl-cart-drawer]');
    var cur = root();
    if (!fresh || !cur) return -1;
    var wasOpen = keepOpen || (drawer() && drawer().classList.contains('active'));
    cur.replaceWith(fresh);
    if (wasOpen) { var d = drawer(); d.classList.add('animate', 'active'); }
    bind();
    var n = parseInt(fresh.getAttribute('data-cl-count') || '-1', 10);
    if (n >= 0) bubble(n);
    setTimeout(gifts, 0);
    return n;
  }

  /* brindes por meta (app de brinde dele): Sac de lavage >= 95, Pochette >= 130, na moeda da loja (centavos) */
  var giftBusy = false;
  function gifts() {
    var r = root(); if (!r || giftBusy) return;
    var sub = parseInt(r.getAttribute('data-cl-sub') || '0', 10);
    var rules = [[9500, 'data-cl-g1', 'data-cl-g1v'], [13000, 'data-cl-g2', 'data-cl-g2v']];
    for (var i = 0; i < rules.length; i++) {
      var line = parseInt(r.getAttribute(rules[i][1]) || '0', 10);
      var vid = parseInt(r.getAttribute(rules[i][2]) || '0', 10);
      if (!vid) continue;
      if (sub >= rules[i][0] && !line && sub > 0) { giftBusy = true; post('/cart/add.js', { items: [{ id: vid, quantity: 1 }] }).then(done, done); return; }
      if (sub < rules[i][0] && line) { giftBusy = true; change(line, 0).then(done, done); return; }
    }
    syncCodes();
    function done() { giftBusy = false; setTimeout(gifts, 0); }
  }

  // render separado (icone do header): sem cache; se a contagem nao bater com /cart.js, tenta de novo
  function refresh(keepOpen, tries) {
    tries = tries || 0;
    var r = root(); if (r) r.setAttribute('aria-busy', 'true');
    var url = window.location.pathname + '?sections=' + SECTION + '&_=' + Date.now();
    return Promise.all([
      // sem Accept: application/json — em /collections/x e /products/x ele devolve o JSON do recurso, nao as secoes
      fetch(url, { cache: 'no-store' }).then(function (res) { return res.json(); }),
      fetch('/cart.js?_=' + Date.now(), { headers: { 'Accept': 'application/json' }, cache: 'no-store' }).then(function (res) { return res.json(); })
    ]).then(function (out) {
      var n = apply(out[0] && out[0][SECTION], keepOpen);
      var real = out[1] && out[1].item_count;
      if (typeof real === 'number') bubble(real);
      if (typeof real === 'number' && n !== real && tries < 4) {
        return new Promise(function (ok) { setTimeout(ok, 400 * (tries + 1)); }).then(function () { return refresh(keepOpen, tries + 1); });
      }
    }).catch(function () {})
      .then(function () { var r3 = root(); if (r3) r3.removeAttribute('aria-busy'); });
  }

  /* toda mutacao pede a gaveta renderizada NA resposta (sections=): a Section Rendering separada
     logo depois do POST ainda devolve o carrinho anterior (gaveta "vazia" ate o F5) */
  function post(url, body) {
    var r = root(); if (r) r.setAttribute('aria-busy', 'true');
    var isForm = (typeof FormData !== 'undefined') && body instanceof FormData;
    if (isForm) { body.append('sections', SECTION); body.append('sections_url', window.location.pathname); }
    else { body.sections = SECTION; body.sections_url = window.location.pathname; }
    var opts = { method: 'POST', headers: { 'Accept': 'application/json' }, body: isForm ? body : JSON.stringify(body) };
    if (!isForm) opts.headers['Content-Type'] = 'application/json';
    return fetch(url, opts).then(function (res) {
      return res.json().then(function (j) { return { ok: res.ok, j: j }; });
    }).then(function (res) {
      if (!res.ok) { var r2 = root(); if (r2) r2.removeAttribute('aria-busy'); return res; }
      var html = res.j && res.j.sections && res.j.sections[SECTION];
      var n = apply(html, true);
      var r3 = root(); if (r3) r3.removeAttribute('aria-busy');
      if (n < 0) return refresh(true).then(function () { return res; });
      if (typeof res.j.item_count === 'number') bubble(res.j.item_count);
      else fetch('/cart.js?_=' + Date.now(), { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
        .then(function (x) { return x.json(); }).then(function (c) { bubble(c.item_count); }).catch(function () {});
      return res;
    }).catch(function () {
      // rw 11-01: resposta nao-JSON / rede: tira o aria-busy e mostra o carrinho real
      var r4 = root(); if (r4) r4.removeAttribute('aria-busy');
      return refresh(true).then(function () { return { ok: false, j: null }; });
    });
  }

  function change(line, qty) {
    return post('/cart/change.js', { line: line, quantity: qty });
  }

  function addonVariant(card) {
    var data = card.querySelector('script[data-addon-variants]');
    if (!data) return null;
    var list = []; try { list = JSON.parse(data.textContent); } catch (e) { return null; }
    var sel = Array.prototype.map.call(card.querySelectorAll('[data-addon-option-select]'), function (s) { return s.value; });
    for (var i = 0; i < list.length; i++) {
      var ok = true;
      for (var k = 0; k < sel.length; k++) if (list[i].options[k] !== sel[k]) { ok = false; break; }
      if (ok) return list[i];
    }
    return list[0] || null;
  }

  /* codigos: o do kit (maior faixa atingida por produto, window.clBundleCodes de snippets/cl-bundle-codes) + o digitado */
  var codeBusy = false;
  function manual() { try { return sessionStorage.getItem('cl-code') || ''; } catch (e) { return ''; } }
  // rw 11-01: o kit e o app Kaching REAL (desconto automatico do app) e o campo de codigo saiu da gaveta: os codigos
  // KIT-* da replica nao sao mais aplicados; se algum estiver no carrinho ele sai, os demais ficam como estao.
  var KACHING = true;
  function wanted(cart) {
    if (KACHING) return (cart.discount_codes || []).map(function (c) { return c.code || ''; }).filter(function (c) { return c && !/^KIT-/i.test(c); });
    var map = window.clBundleCodes || {}, qty = {}, out = [];
    (cart.items || []).forEach(function (it) { qty[it.handle] = (qty[it.handle] || 0) + it.quantity; });
    Object.keys(qty).forEach(function (h) {
      var best = null; (map[h] || []).forEach(function (t) { if (qty[h] >= t[0]) best = t[1]; });
      if (best) out.push(best);
    });
    if (manual()) out.push(manual());
    return out;
  }
  function syncCodes(force) {
    if (codeBusy) return Promise.resolve(null);
    return fetch('/cart.js?_=' + Date.now(), { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); }).then(function (cart) {
        var want = wanted(cart);
        var a = want.map(function (x) { return x.toUpperCase(); }).sort().join(',');
        var b = (cart.discount_codes || []).map(function (c) { return (c.code || '').toUpperCase(); }).sort().join(',');
        if (a === b && !force) return null;
        codeBusy = true;
        return post('/cart/update.js', { discount: want.join(',') }).then(function (res) { codeBusy = false; return res; }, function () { codeBusy = false; });
      }).catch(function () { codeBusy = false; });
  }
  window.clSyncCodes = syncCodes;

  function promo(pr) {
    var inp = pr.querySelector('[data-cl-promo-input]');
    var code = (inp && inp.value || '').trim();
    var msg = pr.querySelector('[data-cl-promo-msg]');
    if (!code) { if (inp) inp.focus(); return; }
    try { sessionStorage.setItem('cl-code', code); } catch (e) {}
    syncCodes(true).then(function (res) {
      var ok = res && res.ok && res.j && (res.j.discount_codes || []).some(function (d) { return d.code.toLowerCase() === code.toLowerCase() && d.applicable; });
      if (!ok) { try { sessionStorage.removeItem('cl-code'); } catch (e) {} }
      if (!ok) {
        var m = root() && root().querySelector('[data-cl-promo-msg]');
        var box = root() && root().querySelector('.cl-promo__box');
        if (box) { box.hidden = false; box.closest('[data-cl-promo]').classList.add('is-open'); }
        if (m) { m.hidden = false; m.textContent = 'Ce code promo n’est pas valide pour ce panier.'; }
      }
    });
  }

  function bind() {
    var r = root(); if (!r || r.__clb) return;
    r.__clb = true;
    r.addEventListener('click', function (e) {
      if (e.target.closest('[data-cl-cart-close]')) { e.preventDefault(); close(); return; }
      var q = e.target.closest('[data-cl-qty]');
      if (q) {
        e.preventDefault();
        var row = q.closest('[data-cl-line]');
        var inp = row.querySelector('.quantity__input');
        var n = Math.max(0, parseInt(inp.value || '0', 10) + parseInt(q.getAttribute('data-cl-qty'), 10));
        inp.value = n;
        change(parseInt(row.getAttribute('data-cl-line'), 10), n);
        return;
      }
      var rm = e.target.closest('[data-cl-remove]');
      if (rm) { e.preventDefault(); change(parseInt(rm.closest('[data-cl-line]').getAttribute('data-cl-line'), 10), 0); return; }
      var up = e.target.closest('[data-cl-up]');
      if (up) {
        var tr = up.closest('.ts-upsale').querySelector('[data-cl-track]');
        var c0 = tr && tr.querySelector('.upsale-card');
        if (tr && c0) tr.scrollBy({ left: parseInt(up.getAttribute('data-cl-up'), 10) * (c0.getBoundingClientRect().width + 10), behavior: 'smooth' });
        return;
      }
      var tg = e.target.closest('[data-cl-promo-toggle]');
      if (tg) {
        var pr = tg.closest('[data-cl-promo]'); var box = pr.querySelector('.cl-promo__box');
        box.hidden = !box.hidden; pr.classList.toggle('is-open', !box.hidden);
        if (!box.hidden) { var ii = box.querySelector('input'); if (ii) ii.focus(); }
        return;
      }
      var ap = e.target.closest('[data-cl-promo-apply]');
      if (ap) { e.preventDefault(); promo(ap.closest('[data-cl-promo]')); return; }
      var add = e.target.closest('[data-addon-add]');
      if (add) {
        e.preventDefault();
        var card = add.closest('[data-cl-addon]');
        var v = addonVariant(card);
        if (!v || !v.available) return;
        add.setAttribute('aria-busy', 'true');
        post('/cart/add.js', { items: [{ id: v.id, quantity: 1 }] });
      }
    });
    r.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.closest('[data-cl-promo-input]')) { e.preventDefault(); promo(e.target.closest('[data-cl-promo]')); }
      if ((e.key === 'Enter' || e.key === ' ') && e.target.closest('[data-addon-add]')) { e.preventDefault(); e.target.click(); }
    });
    r.addEventListener('change', function (e) {
      var inp = e.target.closest('.quantity__input');
      if (inp) { change(parseInt(inp.closest('[data-cl-line]').getAttribute('data-cl-line'), 10), Math.max(0, parseInt(inp.value || '0', 10))); return; }
      var s = e.target.closest('[data-addon-option-select]');
      if (s) {
        var card = s.closest('[data-cl-addon]');
        var v = addonVariant(card);
        if (!v) return;
        card.setAttribute('data-variantid', v.id);
        var img = card.querySelector('[data-addon-image]'); if (img && v.image) img.src = v.image;
        var p = card.querySelector('[data-addon-price]'); if (p) p.innerHTML = v.price;
        var cw = card.querySelector('[data-addon-compare-wrap]');
        var cp = card.querySelector('[data-addon-compare-price] .money');
        if (cw) cw.style.display = v.compareAtPrice ? '' : 'none';
        if (cp) cp.innerHTML = v.compareAtPrice || '';
        var b = card.querySelector('[data-addon-add]'); if (b) b.disabled = !v.available;
      }
    });
  }

  // cl:cart:open com detail.added = o add ja aplicou a gaveta da resposta: so abre
  document.addEventListener('cl:cart:open', function (e) {
    if (e.detail && e.detail.added) { open(); return; }
    open(); refresh(true);
  });
  window.clCartPost = post;
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  window.clCartRefresh = refresh;
  window.clCartClose = close;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind); else bind();
})();
